export default __webpack_public_path__ + "static/media/undraw_Taken_re_yn20.10e1ef60.svg";